// Helper aditivo B-01 (fase 8, feb-2026).
// Formatea un campo `domicilio` que en la plataforma conviven en dos formas:
//   1) string simple (mayoría de clientes creados por UI)
//   2) objeto { calle, numero, colonia, municipio, estado, cp, pais } (fixtures/seeds)
//
// Regla ADITIVA: no cambia lógica de negocio, no toca datos, no modifica cobranza.py.
// Su único trabajo es garantizar que la UI reciba SIEMPRE un string imprimible.
//
// Casos:
//   - string no vacío   → se devuelve tal cual (trim opcional para no arrastrar espacios)
//   - null / undefined  → ""
//   - objeto vacío o con todas las llaves en blanco → "" (nunca "," sueltos)
//   - objeto con datos  → "calle numero, Col. colonia, C.P. cp, municipio, estado[, pais]"
//
// No se agregan comas sueltas: cada parte se une con `filter(Boolean)` antes del join.
export function formatDomicilio(input) {
  if (input == null) return "";
  if (typeof input === "string") return input.trim();
  if (typeof input !== "object") return String(input);

  const trim = (v) => (v == null ? "" : String(v).trim());
  const calle = trim(input.calle);
  const numero = trim(input.numero);
  const colonia = trim(input.colonia);
  const cp = trim(input.cp);
  const municipio = trim(input.municipio);
  const estado = trim(input.estado);
  const pais = trim(input.pais);

  const calleNum = [calle, numero].filter(Boolean).join(" ");
  const partes = [
    calleNum,
    colonia ? `Col. ${colonia}` : "",
    cp ? `C.P. ${cp}` : "",
    municipio,
    estado,
    pais && pais !== "MX" ? pais : "",
  ].filter(Boolean);

  return partes.join(", ");
}
